export default "__VITE_ASSET__C_liAgSv__"